import React from 'react'
import Header from '../component/Header'
import './home.css'
import Banner from '../component/Banner'
import AboutSub from '../component/AboutSub'
import WWD from '../component/WWD'
import JoinUS from '../component/JoinUS'
import BottomBar from '../component/BottomBar'
import Donate from '../component/Donate'

function Home() {


  return (
    <div className='home'>
        <Header/>
        <Banner/>
        <div className='danate_mob'>
          <Donate/>
        </div>
        <WWD/>
        <AboutSub/>
        <JoinUS/>
        <BottomBar/>
    </div>
  )
}

export default Home